export default function dataProcessing(value: string | number | boolean) {
  return value === undefined || value === null || value === "" ? "---" : value;
}
